// We want those colors to match colors on https://volt.io
// Unfortunately we don't have these colors in our color pallet
export const COLORS = {
  background: "#050534",
  bigBlur: "#1A52B0",
  smallBlur: "#186FFF",
};
